import { SearchModeToggleSlot } from '#pplx/frontend/apps/ask/composer-sdk-plugins/search-mode-toggle/SearchModeToggleSlot.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
export const createSearchModeTogglePlugin = createPluginFactory({
    name: 'search-mode-toggle',
    capabilities: [
        {
            kind: 'slot',
            components: [{ slot: 'leftAttribution', component: SearchModeToggleSlot }],
        },
    ],
});
//# sourceMappingURL=SearchModeTogglePlugin.js.map